/**
 * Shared constants for UI state and selectors.
 */
export const ACTIVE_CLASS = 'state-active';
export const OPEN_CLASS = 'state-open';
export const LOADED_CLASS = 'state-loaded';
export const LOCKED_CLASS = 'state-locked';

export const FOCUSABLE_ELEMENTS_SELECTOR = [
	'a[href]',
	'button:not([disabled])',
	'textarea:not([disabled])',
	'input:not([disabled]):not([type="hidden"])',
	'select:not([disabled])',
	'summary',
	'[tabindex]:not([tabindex="-1"])'
].join(', ');
